import { render, staticRenderFns } from "./LocationDetailButtons.vue?vue&type=template&id=e0e99580&"
import script from "./LocationDetailButtons.vue?vue&type=script&lang=js&"
export * from "./LocationDetailButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0e99580')) {
      api.createRecord('e0e99580', component.options)
    } else {
      api.reload('e0e99580', component.options)
    }
    module.hot.accept("./LocationDetailButtons.vue?vue&type=template&id=e0e99580&", function () {
      api.rerender('e0e99580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/LocationDetailButtons.vue"
export default component.exports